import {takeLatestF, putAll, showSuccess, extractFormErrorsFromResponse, NullableKeys} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {genNakedPropOrCrash, opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {CreateOtherSubjectBinding} from 'api/gen/CreateOtherSubjectBinding';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {
    managementOtherSubjectFormName,
    ManagementOtherSubjectFormValues,
} from '../../types/management-other-subject-form-values';
import {adminAction, CreateManagementOtherSubjectAction} from '../action';

const te = t('common');
const title = te('createEntry');

const buildValuesForApi = (formValues: NullableKeys<ManagementOtherSubjectFormValues>): CreateOtherSubjectBinding => {
    const get = genNakedPropOrCrash(formValues);

    return {
        approvedFrom: get('approvedFrom'),
        approvedTo: opt(formValues).prop('approvedTo').orNull(),
        roleIds: get('roleIds'),
        otherSubjectId: get('subjectId'),
        userProfileId: get('userProfileId'),
    };
};

function* execute({payload: {otherSubjectId}}: CreateManagementOtherSubjectAction): SagaIterator {
    const formValues = yield* select(state => formHelpers.formValues(managementOtherSubjectFormName)(state)
        .orCrash(`no form values: ${managementOtherSubjectFormName}`));
    yield* put(formHelpers.startSubmit(managementOtherSubjectFormName));

    const response = yield* call(Api.addUserProfileOtherSubjectRoleBySubjectManager, buildValuesForApi(formValues));

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOtherSubjectsTableData(opt({action: 'refresh'}), opt(otherSubjectId)));
        yield* put(showSuccess(title, te('createEntrySuccess'), false, 'createManagementOtherSubject'));
        yield* put(adminAction.setManagementSubjectModalVisible(null));
        yield* put(formHelpers.reset(managementOtherSubjectFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(managementOtherSubjectFormName, extractFormErrorsFromResponse(response)));
    }
}

/** Runs the admin saga that creates an other-subject management binding from the admin form. */
export function* createManagementOtherSubjectSaga(): SagaIterator {
    yield takeLatestF('admin/CREATE_MANAGEMENT_OTHER_SUBJECT', execute);
}
